import axios from "./axios";

const base = "/biz/amazon/shop-sync";
const post = (path, body = {}) => axios.post(base + path, body, {
  headers: { "Content-Type": "application/json;charset=UTF-8" },
});

export default {
  page: params => axios.get(base + "/page", { params }),
  save: config => post("/save", config),
  setEnabled: (id, enabled) => post(`/${id}/enabled`, { enabled }),
  remove: id => post(`/delete/${id}`),
};
